import { Box } from '@wix/design-system';
import React, { FC, ReactNode } from 'react';

import { ButtonLinkWrapper } from '../ButtonLinkWrapper';

interface Props {
  children: ReactNode;
  onClick?: () => void;
  hasFocus?: boolean;
  link?: string;
}

export const SelectorItem: FC<Props> = ({ children, onClick, hasFocus = false, link }) => {
  return (
    <ButtonLinkWrapper link={link} onClick={onClick} hasFocus={hasFocus} data-hook="item">
      <Box padding="SP2 SP3" direction="vertical" verticalAlign="middle">
        {children}
      </Box>
    </ButtonLinkWrapper>
  );
};
